// TODO: Replace with real endpoint when available
export interface SaveReminderConfigParams {
  deliveryTimeSlot: string;
  address: string;
  reminderStatus: 'ON' | 'OFF';
}

export function useSaveReminderConfig() {
  const saveConfig = async (_config: SaveReminderConfigParams) => {
    // TODO: POST to real API endpoint
    // e.g. await fetch('/api/reminder-config', { method: 'POST', body: JSON.stringify(_config) })
    return Promise.resolve({ success: true });
  };

  return { saveConfig };
}
